import React from 'react';
import styles from './Toggle.m.sass';

import cx from 'classnames';

export default class Toggle extends React.PureComponent {
  render() {
    const {leftLabel, rightLabel, isToggled, onToggle, small} = this.props;

    return (
      <div
        className={cx(
          styles.toggle,
          {[styles.small]: small},
        )}
      >
        <div className={styles.toggleWrapper}>
          <input
            type="radio"
            id="switch_left"
            name="switchToggle"
            className={styles.toggleInput}
            value={leftLabel}
            onChange={() => isToggled && onToggle(false)}
            checked={!isToggled}
          />
          <label htmlFor="switch_left" className={styles.toggleLabel}>
            <span className={styles.toggleLabelText}>{this.props.leftLabel}</span>
          </label>

          <input
            type="radio"
            id="switch_right"
            name="switchToggle"
            className={styles.toggleInput}
            value={rightLabel}
            onChange={() => isToggled || onToggle(true)}
            checked={isToggled}
          />
          <label htmlFor="switch_right" className={styles.toggleLabel}>
            <span className={styles.toggleLabelText}>{this.props.rightLabel}</span>
          </label>

          <span className={styles.toggleHighlight}>
            <span className={styles.toggleHighlightInner}/>
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/toggle/Toggle.js